import React from "react";

export const CustomError = ({ schema, uiSchema }) => {
  const apiError = uiSchema["ui:apiError"];
  const errorName = uiSchema["ui:errorName"];
  const isError = !!errorName || !!apiError;

  if (!isError || !schema.errors) return null;

  const error = errorName && schema.errors[errorName];
  const [text, url] = error ? error.split('|') : apiError ? apiError.split("|") : ["", ""];
  const [beforeLink, middleText, afterLink] = text.split('*');

  return (
    <p className={"extra-text extra-text--error"}>
      {beforeLink && beforeLink}
      {(middleText && url) ?
        <a href={url} target="_blank" rel="noopener noreferrer">{middleText}</a> :
        middleText ? middleText : null
      }
      {afterLink && afterLink}
    </p>
  )

}
